'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /*
                                                                                                                                                                                                                              * @Author: edconstdchen
                                                                                                                                                                                                                              * @Date:   2016-08-15 20:10:51
                                                                                                                                                                                                                              * @Last Modified by: jerryfwang
                                                                                                                                                                                                                              * @Last Modified time: 2020-08-24 11:39:14
                                                                                                                                                                                                                              */


var videoChMap = {
  wechathot: '003902',
  coolread: '003901',
  tag: '003901'
};
/**
 * 生成正文url
 * @param  {Object} data
 * @param  {String} data.business 业务名称
 * @param  {String} data.docId
 * @param  {Number} [data.dataSrc] 文章来源ID
 * @param  {String} [data.url] 文章原网址
 * @param  {Boolean} [data.showAttach] 是否展示夹带
 * @param  {Number} [data.clientWidth] 终端宽度
 * @param  {String} [data.tabId]
 * @param  {String} [data.tagId]
 * @param  {String} [data.ch]
 * @param  {String} [data.root]
 * @return {String}
 */
function buildArticleUrl(_ref) {
  var business = _ref.business,
      showAttach = _ref.showAttach,
      _ref$env = _ref.env,
      env = _ref$env === undefined ? 'production' : _ref$env,
      _ref$root = _ref.root,
      root = _ref$root === undefined ? '' : _ref$root,
      _ref$host = _ref.host,
      host = _ref$host === undefined ? '' : _ref$host,
      rest = _objectWithoutProperties(_ref, ['business', 'showAttach', 'env', 'root', 'host']);

  var rootstring = (showAttach ? '' : 'lite') + 'article';
  if (root) {
    rootstring = root;
  }
  var _h = host || 'news' + (env !== 'test' ? '' : '.sparta') + '.html5.qq.com';
  var base = 'https://' + _h + '/' + rootstring + '?';
  return base + _queryString2.default.stringify(_extends({}, rest, {
    video_ch: videoChMap[business]
  }));
}

exports.default = buildArticleUrl;